import { apiRequest } from '@/utils/api-request';
import { NotificationPreferencesResponse } from '@/types/notification-types';
import * as Sentry from '@sentry/react';

export async function getNotificationPreferences(
  orgId: string,
  signal?: AbortSignal,
): Promise<NotificationPreferencesResponse> {
  try {
    const response = await apiRequest<NotificationPreferencesResponse>({
      url: `/orgs/${orgId}/notification-preferences`,
      target: 'notifications',
      method: 'GET',
      signal,
    });

    return response.data ?? { items: [] };
  } catch (error) {
    Sentry.captureException(error, {
      extra: { context: 'get-notification-preferences', orgId },
    });
    throw error;
  }
}
